import React, { useState } from "react";
import { Button, Tab, Table, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams, useRouteLoaderData } from "react-router-dom";

import { useAppApi, useAppContext } from "@/App";
import { DevForm } from "@components/Forms/Fields";
import { RenderForm } from "@components/Forms/Render";
import { Awesome, DevModal } from "@components/Helpers";
import { ModalDelete } from "@components/Modals";
import { CommonCard, ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function GameItems(props) {
    const params = useParams();
    if (params.itemdefid) {
        props = { ...props, itemdefid: params.itemdefid };
        return <Versions {...props} />;
    }
    return <Main {...props} />;
}

function Main({ gameId, header }) {
    const { t } = useTranslation();
    const commonInfo = useRouteLoaderData("commonInfo");
    const { apiData, setApiData } = useAppApi(url_reverse("api:game:gameitems", { game_id: gameId }));
    const { setDelData } = useAppContext();
    const [jsonInfo, setJsonInfo] = useState(null);

    if (!apiData) return;

    const delConfirmation = (item) => {
        const url = url_reverse("games:gameitem:versions", { game_id: gameId, itemdefid: item.itemdefid });
        return (
            <>
                <div>
                    {t("Удалить")} itemdefid={item.itemdefid} ({item.name || item.name_english || item.name_russian})?
                </div>
                <div>
                    {t("История редактирования сохранится и будет доступна по ссылке")}{" "}
                    <a href={url} target="_blank">
                        {url}
                    </a>
                </div>
            </>
        );
    };

    return (
        <CommonCard header={header}>
            <ModalDelete />

            <DevModal
                size="xl"
                show={jsonInfo}
                onHide={() => setJsonInfo(null)}
                header="json"
                body={jsonInfo && <pre>{JSON.stringify(jsonInfo, null, 2)}</pre>}
            />

            <Tabs defaultActiveKey="items" transition={false} className="react-bootstrap-tabs-fix">
                <Tab eventKey="items" title={t("Список игровых товаров")}>
                    <Table responsive className="dmg-table">
                        <thead>
                            <tr>
                                <th>{t("Название")}</th>
                                <th>itemdefid</th>
                                <th>{t("Тип")}</th>
                                <th>{t("Обновлено")}</th>
                                <th />
                                <th />
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {apiData.itemdef_data?.map((item) => (
                                <tr key={`itemdef_${item.itemdefid}`}>
                                    <td>{item.name || item.name_english || item.name_russian}</td>
                                    <td>{item.itemdefid}</td>
                                    <td>{item.type}</td>
                                    <td>{item.time_update}</td>
                                    <td>
                                        <Button size="sm" variant="light" onClick={() => setJsonInfo(item)}>
                                            json
                                        </Button>
                                    </td>
                                    <td>
                                        <Link
                                            to={url_reverse("games:gameitem:versions", {
                                                game_id: gameId,
                                                itemdefid: item.itemdefid,
                                            })}
                                        >
                                            {t("Версии")}
                                        </Link>
                                    </td>
                                    <td className="dmg-table-row-tools">
                                        <Awesome
                                            type="trash-o"
                                            color="red"
                                            onClick={() =>
                                                setDelData({
                                                    url: url_reverse(
                                                        "api:game:gameitems",
                                                        { game_id: gameId },
                                                        { itemdefid: item.itemdefid }
                                                    ),
                                                    confirmation: delConfirmation(item),
                                                    afterRespOK: (resp) => {
                                                        const newApiData = { ...apiData };
                                                        newApiData.itemdef_data = apiData.itemdef_data.filter(
                                                            (o) => o.itemdefid !== resp.itemdefid
                                                        );
                                                        setApiData(newApiData);
                                                    },
                                                })
                                            }
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Tab>
                {apiData.can_edit && (
                    <Tab eventKey="json" title={t("Загрузка json")}>
                        <RenderForm prefix="json" />
                    </Tab>
                )}
                {apiData.can_edit && (
                    <Tab eventKey="images" title={t("Загрузка картинок")}>
                        <RenderForm prefix="images" />
                        {apiData.images_list.length > 0 && (
                            <>
                                <Table responsive className="dmg-table">
                                    <thead>
                                        <tr>
                                            <th />
                                            <th>{t("Файл")}</th>
                                            <th>{t("Обновлено")}</th>
                                            <th>{t("Ссылка")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {apiData.images_list?.map((o, ind) => (
                                            <tr key={`image_${o.id}`}>
                                                <td>
                                                    <DevForm.Checkbox
                                                        checked={o.chosen}
                                                        onChange={(ev) => {
                                                            const newApiData = { ...apiData };
                                                            newApiData.images_list[ind].chosen = ev.target.checked;
                                                            setApiData(newApiData);
                                                        }}
                                                    />
                                                </td>
                                                <td>{o.name}</td>
                                                <td>{o.date}</td>
                                                <td>
                                                    <a
                                                        href={`https://${commonInfo.domain_showcase}/hotbox/showcase/${o.path}`}
                                                        target="_blank"
                                                    >
                                                        {o.path}
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                <Button
                                    variant="danger"
                                    onClick={() => {
                                        const ids = apiData.images_list.filter((o) => o.chosen).map((o) => o.id);
                                        if (ids.length) {
                                            setDelData({
                                                url: url_reverse(
                                                    "api:game:gameitems",
                                                    { game_id: gameId },
                                                    { images_ids: ids }
                                                ),
                                                afterRespOK: (resp) => {
                                                    const newApiData = { ...apiData };
                                                    newApiData.images_list = apiData.images_list.filter(
                                                        (o) => !resp.ids.includes(o.id)
                                                    );
                                                    setApiData(newApiData);
                                                },
                                            });
                                        }
                                    }}
                                >
                                    {t("Удалить выбранное")}
                                </Button>
                            </>
                        )}
                    </Tab>
                )}
            </Tabs>
        </CommonCard>
    );
}

function Versions({ gameId, itemdefid, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:game:gameitems:versions", { game_id: gameId, itemdefid }));
    const [jsonInfo, setJsonInfo] = useState(null);

    if (!apiData) return;

    return (
        <ListingCard header={header}>
            <DevModal
                size="xl"
                show={jsonInfo}
                onHide={() => setJsonInfo(null)}
                header="json"
                body={jsonInfo && <pre>{JSON.stringify(jsonInfo, null, 2)}</pre>}
            />
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>itemdefid</th>
                        <th>{t("Версия")}</th>
                        <th>{t("Обновлено")}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, i) => {
                        return (
                            <tr key={`object_list${i}`}>
                                <td>{o.itemdefid}</td>
                                <td>{o.version}</td>
                                <td>{o.time_update}</td>
                                <td>
                                    <Button size="sm" variant="light" onClick={() => setJsonInfo(o)}>
                                        json
                                    </Button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}
